export default __webpack_public_path__ + "static/media/03.b3dd2421.jpg";